//eslint-disable-next-line
export default {
    title: 'dark',

    colors: {
        primary: ' #000229;',
        secondary: '#252a48',
        tertiary: '#313862',

        white: '#fff',
        black: '#000',
        gray: '#bfbfbf',

        success: '#4e41f0',
        info: '#000229',
        warning: '#e44c4e'

    }
};